(function () {
  const revealSelector = '[data-scroll-reveal]';
  const staggerSelector = '[data-scroll-reveal-stagger]';
  const visibleClass = 'is-scroll-revealed';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.add('scroll-reveal-disabled');
    return;
  }

  const prepareStaggerItems = (container) => {
    const items = Array.from(container.querySelectorAll(revealSelector));

    items.forEach((item, index) => {
      if (item.style.getPropertyValue('--scroll-reveal-delay')) return;
      item.style.setProperty('--scroll-reveal-delay', `${Math.min(index * 80, 480)}ms`);
    });
  };

  const reveal = (element, observer) => {
    element.classList.add(visibleClass);
    observer.unobserve(element);
  };

  const initialize = (root = document) => {
    if (!('IntersectionObserver' in window)) {
      root.querySelectorAll(revealSelector).forEach((element) => element.classList.add(visibleClass));
      return;
    }

    root.querySelectorAll(staggerSelector).forEach(prepareStaggerItems);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) reveal(entry.target, observer);
        });
      },
      {
        rootMargin: '0px 0px -14% 0px',
        threshold: 0.12,
      }
    );

    root.querySelectorAll(revealSelector).forEach((element) => {
      if (element.classList.contains(visibleClass)) return;
      observer.observe(element);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
